export enum SellerToolType {
    OpenInvitation = 'OpenInvitation',
    ProspectDemos = 'ProspectDemos',
    WorkshopAccounts = 'WorkshopAccounts'
}
